import clsx from "clsx";

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  hint?: string;
  disabled?: boolean;
  size?: "sm" | "md";
}

export function Toggle({ checked, onChange, label, hint, disabled, size = "md" }: ToggleProps) {
  const track = size === "sm" ? "w-8 h-4" : "w-10 h-5";
  const knob = size === "sm" ? "w-3 h-3" : "w-4 h-4";
  const knobTranslate = size === "sm" ? "translate-x-4" : "translate-x-5";

  return (
    <label className={clsx("inline-flex items-center gap-3 select-none", disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer")}>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={() => !disabled && onChange(!checked)}
        className={clsx(
          "relative rounded-full transition-colors shrink-0",
          track,
          checked ? "bg-accent" : "bg-line border border-line",
        )}
      >
        <span
          className={clsx(
            "absolute top-0.5 left-0.5 bg-white rounded-full transition-transform shadow",
            knob,
            checked && knobTranslate,
          )}
        />
      </button>
      {(label || hint) && (
        <div className="flex flex-col">
          {label && <span className="text-sm">{label}</span>}
          {hint && <span className="text-xs text-muted">{hint}</span>}
        </div>
      )}
    </label>
  );
}
